const HomeSection: React.FC = () => {
  return (
    <>
      <p>Admin Dashboard coming soon..</p>
    </>
  );
};
export default HomeSection;
